import React, { useEffect, useState, useMemo } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebaseConfig";
import Podium from "./Podium";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

const RankingGarcons = () => {
  const [rankingGarcons, setRankingGarcons] = useState([]);
  const [garconsDisponiveis, setGarconsDisponiveis] = useState([]);
  const [filtroNome, setFiltroNome] = useState("");
  const [garcom1, setGarcom1] = useState("");  // ✅ Adicionado
  const [garcom2, setGarcom2] = useState("");  // ✅ Adicionado
  const [ordenacao, setOrdenacao] = useState("totalAtendimentos");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [carregando, setCarregando] = useState(false);
  

  // 🔹 Obtém a data atual para filtrar apenas os atendimentos do dia ao iniciar
  const hoje = new Date().toISOString().split("T")[0];

  useEffect(() => {
    buscarDados(hoje, hoje);
  }, []);

  // 🔥 Função para buscar os dados do Firestore dentro do intervalo selecionado
  const buscarDados = (inicio, fim) => {
    setCarregando(true);

    const q = query(collection(db, "chamadas"), where("status", "==", "finalizado"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const garconsMap = {};

      snapshot.forEach((doc) => {
        const data = doc.data();
        if (!data.garcom || !data.data_hora) return;

        // 🔹 Extrai a parte da data, ignorando a hora
        const dataFormatada = data.data_hora.split(" ")[0]; // "YYYY-MM-DD"

        // 🔹 Verifica se está no intervalo selecionado
        if (dataFormatada < inicio || dataFormatada > fim) return;

        if (!garconsMap[data.garcom]) {
          garconsMap[data.garcom] = { nome: data.garcom, atendimentos: 0, solicitacoesConta: 0 };
        }

        if (data.tipo === "chamada") {
          garconsMap[data.garcom].atendimentos += 1;
        } else if (data.tipo === "conta") {
          garconsMap[data.garcom].solicitacoesConta += 1;
        }
      });

      const ranking = Object.values(garconsMap);
      setRankingGarcons(ranking);
      setGarconsDisponiveis(ranking.map((g) => g.nome));
      setCarregando(false);
    });

    return () => unsubscribe();
  };

  // 🔹 Filtragem e ordenação otimizadas
// 🔹 Filtragem e ordenação otimizadas
const garconsFiltrados = useMemo(() => {
  return rankingGarcons
    .filter((garcom) => {
      if (garcom1 && garcom2) {
        return garcom.nome === garcom1 || garcom.nome === garcom2;
      }
      return filtroNome ? garcom.nome === filtroNome : true;
    })
    .sort((a, b) => {
      if (ordenacao === "totalAtendimentos") return b.atendimentos - a.atendimentos;
      if (ordenacao === "solicitacoesConta") return b.solicitacoesConta - a.solicitacoesConta;
      if (ordenacao === "totalSolicitacoes") return (b.atendimentos + b.solicitacoesConta) - (a.atendimentos + a.solicitacoesConta); // 🔹 Nova ordenação
      return 0;
    });
}, [rankingGarcons, filtroNome, ordenacao, garcom1, garcom2]);


// 🔹 Mantém o top 5 garçons baseado na filtragem
const top5Garcons = useMemo(() => garconsFiltrados.slice(0, 5), [garconsFiltrados]);

  // 🔹 Exportação CSV
  const exportCSV = () => {
    const csvData = garconsFiltrados.map((garcom) => ({
      Nome: garcom.nome,
      "Atendimentos Finalizados": garcom.atendimentos,
      "Solicitações de Conta": garcom.solicitacoesConta,
      "Total de Solicitações": garcom.atendimentos + garcom.solicitacoesConta,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `ranking_garcons_${dataInicio}_${dataFim}.csv`);
  };

  // 🔹 Exportação PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text(`Ranking dos Garçons (${dataInicio} - ${dataFim})`, 14, 10);

    const tableData = garconsFiltrados.map((garcom, index) => [
      index + 1,
      garcom.nome,
      garcom.atendimentos,
      garcom.solicitacoesConta,
      garcom.atendimentos + garcom.solicitacoesConta,
    ]);

    doc.autoTable({
      head: [["#", "Garçom", "Atendimentos", "Solicitações de Conta", "Total"]],
      body: tableData,
      theme: "grid",
      styles: { fontSize: 10, halign: "center" },
      headStyles: { fillColor: [44, 62, 80] },
    });

    doc.save(`ranking_garcons_${dataInicio}_${dataFim}.pdf`);
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4"></h2>
      {/* 🔹 Filtros */}
      <div className="row mb-4 p-3 bg-light rounded shadow-sm">
        {/* Comparação entre dois garçons */}
        <div className="col-md-3">
          <label className="form-label">Comparar Garçom 1</label>
          <select className="form-control" value={garcom1} onChange={(e) => setGarcom1(e.target.value)}>
            <option value="">Selecione</option>
            {garconsDisponiveis.map((nome) => (
              <option key={nome} value={nome}>{nome}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label">Comparar Garçom 2</label>
          <select className="form-control" value={garcom2} onChange={(e) => setGarcom2(e.target.value)}>
            <option value="">Selecione</option>
            {garconsDisponiveis.map((nome) => (
              <option key={nome} value={nome}>{nome}</option>
            ))}
          </select>
        </div>

       {/* Ordenação */}
<div className="col-md-3">
  <label className="form-label">Ordenar por</label>
  <select className="form-control" value={ordenacao} onChange={(e) => setOrdenacao(e.target.value)}>
    <option value="totalAtendimentos">Atendimentos Finalizados</option>
    <option value="solicitacoesConta">Solicitações de Conta</option>
    <option value="totalSolicitacoes">Total de Solicitações</option> {/* 🔹 Nova opção adicionada */}
  </select>
</div>


        {/* Data Início */}
        <div className="col-md-3">
          <label className="form-label">Data Início</label>
          <input type="date" className="form-control" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
        </div>

        {/* Data Fim */}
        <div className="col-md-3">
          <label className="form-label">Data Fim</label>
          <input type="date" className="form-control" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
        </div>
      </div>

      <button className="btn btn-success mb-3" onClick={() => buscarDados(dataInicio, dataFim)}>
        Buscar Dados
      </button>


      {carregando && <p className="text-center">Carregando...</p>}

      {/* 🔹 Tabela de Ranking */}
      <div className="card shadow-lg table-container">
        <div className="card-body">
          <table className="table table-striped text-center">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Garçom</th>
                <th>Atendimentos Finalizados</th>
                <th>Solicitações de Conta</th>
                <th>Total de Solicitações</th>
              </tr>
            </thead>
            <tbody>
              {garconsFiltrados.length > 0 ? (
                garconsFiltrados.map((garcom, index) => (
                  <tr key={garcom.nome}>
                    <td>{index + 1}</td>
                    <td><strong>{garcom.nome}</strong></td>
                    <td className="text-success">{garcom.atendimentos}</td>
                    <td className="text-warning">{garcom.solicitacoesConta}</td>
                    <td className="text-primary"><strong>{garcom.atendimentos + garcom.solicitacoesConta}</strong></td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5">Sem dados disponíveis.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Podium garcons={top5Garcons} />
    </div>
  );
};

export default RankingGarcons;
